import React, { Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useEffectOnce from 'hooks/useEffectOnce';
import {
  setShowPrint,
} from 'stores/slice/cyber';
import FullscreenLoader from 'components/atoms/fullscreenloader';

const PrintPPTX = lazy(() => import('components/atoms/printpptx'));

function PPTX() {
  const { showPrint } = useSelector((state) => state.cyber);
  const dispatch = useDispatch();
  useEffectOnce(() => {
    dispatch(setShowPrint(true));
  });

  return (
    <div>
      {showPrint && (
        <Suspense fallback={<FullscreenLoader />}>
          <PrintPPTX />
        </Suspense>
      )}
    </div>
  );
}

export default PPTX;
